import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { useNavigate, useParams } from 'react-router-dom';
import TrackService from '../services/TrackService'
import MapComponent from './MapComponent'
import DateUtils from '../utils/DateUtils';
import { useAuth } from '../context/AuthContext';
import back from '../assets/back.svg';
import LastPoint from '../utils/LastPoint';

const Content = styled.div`
    height: 100%;
    display: grid;    
    grid-template-rows: 80px 140px auto;
`
const Header = styled.div`
    padding-top:15px;
    padding-bottom: 15px;
    display: flex;
    justify-content: space-between;
`

const Table = styled.div``

const MapContainer = styled.div`
`


const ViewTrackComponent = (props) => {
    let params = useParams();
    const id = params.id;
    const [track, setTrack] = useState({});
    const navigate = useNavigate();
    const { user } = useAuth();

    useEffect(() => {
        TrackService.getTrackById(user, id).then((json) => {setTrack(json.data)});
    }, [id]);
    
    return (
        <Content>
                <Header>
                    <div>
                        <img alt="back" className="backBtn" src={back} onClick={ () => navigate(-1)}></img>
                    </div>
                    <div>
                        <h2 className="text-center">Track #{track.id}</h2>
                    </div>                    
                    <div>
                    </div>
                </Header>
                
                <Table>
                    <div className = "defaultMargin track-table">
                        <table className = "table table-striped table-bordered">
                            <thead className="myClass">
                                <tr>
                                    <th>Vorname</th>
                                    <th>Nachname</th>
                                    <th>Adresse</th>
                                    <th>PLZ</th>
                                    <th>Stadt</th>
                                    <th>Telefon</th>
                                    <th>Mail</th>
                                    <th>Region</th>
                                    <th>letzte gemeldete Position</th>
                                    <th>Zeitpunkt der letzten Übermittlung</th>
                                </tr>
                            </thead>
                            <tbody>
                                    <tr className={track.state === "RUNNING" ? 'table-success' : ''} key = {track.id}>                                
                                        <td> {track.firstname} </td>   
                                        <td> {track.lastname}</td>
                                        <td> {track.address} </td>
                                        <td> {track.postcode} </td>
                                        <td> {track.city} </td>
                                        <td> {track.phone} </td>
                                        <td> {track.mail} </td>
                                        <td> {track.region === "bayern"? "Bayern": "Tirol" } </td>
                                        <td> <LastPoint track={track}/> </td>
                                        <td> <DateUtils timestamp={track.lastTimestamp}/> </td>
                                    </tr>
                            </tbody>
                        </table>
                    </div>
                </Table>
                
                <MapContainer>
                    {track != null && track.positions != null && track.positions.length > 0 &&
                        <div className='defaultMargin track-table mapContainer'>
                            <MapComponent data={track}></MapComponent>
                        </div>
                    }
                </MapContainer>
        </Content>
        
    )
}

export default ViewTrackComponent